import { Component, Input } from '@angular/core';

import { IAirSector } from 'libraries/service/resources/model/search/air/IAirSector';

@Component({
    selector: 'sectors-air-summary-with-rupture',
    template: `
        <ng-container *ngFor="let sector of sectors; let i = index let last = last; let even = even;">
            <sector-air-summary [class.even]="even"
                                [sector]="sector"
                                [showIcon]="false"
                                [showHost]="false"
                                [inlineDirections]="inline"></sector-air-summary>

            <rupture *ngIf="!last && sector.to.airport.code !== sectors[i + 1].from.airport.code"></rupture>
        </ng-container>
    `,
    styles: [`
        sector-air-summary {
            display: block;
            padding: .75rem;
        }

        .even {
            background-color: #f9f8f8;
        }
    `]
})
export class SectorsAirSummaryWithRuptureComponent {
    @Input()
    public sectors: IAirSector[];

    @Input()
    public inline: boolean = true;
}